import styles from './ElevatedButton.module.scss';

export interface ElevatedButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  text: string;
  variant: 'primary' | 'secondary';
}

function ElevatedButton({
  text,
  variant,
  ...buttonProps
}: ElevatedButtonProps): JSX.Element {
  return (
    <button
      className={`
          ${styles.elevatedButton} 
          ${styles[variant]} 
        `}
      type="button"
      {...buttonProps}
    >
      {text}
    </button>
  );
}

export default ElevatedButton;
